// La membresía que trae un enlace `?planes=1&producto=<id>` (el botón de
// mipae.cl/precios o el de un correo), leída de la URL. Puro: no guarda nada.
// La vuelta de Google ya restaura esos parámetros (lib/retornoPlanes.js).
//
// Lo usa App (auditoría de conversión del 25-oct-2026) para dos cosas: que la
// portada sin sesión diga qué membresía eligió la persona antes de pedirle que
// entre, y para medir de qué membresía llegó. Solo ids del catálogo: un valor
// inventado en la URL no se nombra ni se mide.

import { PRODUCTOS_PLUS } from './productosPlus';

export function intencionDesdeUrl(search) {
  let params;
  try { params = new URLSearchParams(search || ''); } catch { return null; }
  if (params.get('planes') !== '1') return null;
  const producto = params.get('producto');
  return { producto: Object.prototype.hasOwnProperty.call(PRODUCTOS_PLUS, producto) ? producto : null };
}

// Cómo nombrarla en la portada: la membresía elegida o, si el enlace no traía
// una válida, la frase genérica. Null si no hay intención.
export function nombreIntencion(intencion) {
  if (!intencion) return null;
  return PRODUCTOS_PLUS[intencion.producto]?.nombre || 'tu membresía Plus';
}
